module.exports = __webpack_public_path__ + "img/1B.d41691df.jpg";